import { PayloadAction } from '@reduxjs/toolkit'
import { LabelProcessingTypeEnum } from 'Modules/Communication/shared/models/Labels'
import { put, takeEvery, select, call } from 'redux-saga/effects'
import { IClient } from 'shared/models/Client'
import { getActiveClient } from 'shared/store/clients/selectors'
import {
  fetchEmailLabelsRequest,
  createEmailLabelRequested,
  fetchEmailLabelDetailsSuccess,
  fetchEmailLabelsError,
  fetchEmailLabelsSuccess,
  updateEmailLabelError,
  updateEmailLabelSuccess,
  updateEmailLabelRequested,
  fetchEmailLabelDetailsRequest,
  createEmailLabelError,
  createEmailLabelSuccess,
} from '.'
import {
  deleteLabel,
  getLabel,
  getLabels,
  updateLabel as updateLabelApi,
  createLabel as createLabelApi,
} from 'Modules/Communication/shared/api/inbox.api'
import { getMappedLabels } from 'Modules/Communication/CommunicationSettings/shared/utils/labels-helpers'
import { getModalState } from 'shared/store/modal/selectors'
import {
  ADD_LABEL_TO_EMAIL_MODAL,
  ADD_LABEL_TO_SMS_MODAL,
  NEW_LABEL_MODAL,
} from 'shared/constants/modals'
import { closeModal, openModal } from 'shared/store/modal'

function* fetchLabels() {
  try {
    const client: IClient = yield select(getActiveClient)

    const { data } = yield call(getLabels, client.id)
    const mappedLabels = getMappedLabels(data.labels)

    yield put(fetchEmailLabelsSuccess(mappedLabels))
  } catch (e: any) {
    console.log(e.response.data)
    yield put(fetchEmailLabelsError(e))
  }
}

function* fetchLabel(action: PayloadAction<string>) {
  try {
    const labelId = action.payload
    const { data } = yield call(getLabel, labelId)

    yield put(fetchEmailLabelDetailsSuccess(data))
  } catch (e: any) {
    console.log(e.response.data)
    // Error is not getting handled
  }
}

function* updateLabel(
  action: PayloadAction<{
    id: string
    path?: string
    type: LabelProcessingTypeEnum
  }>
) {
  try {
    if (action.payload.type === LabelProcessingTypeEnum.edit) {
      yield call(updateLabelApi, action.payload.id, action.payload.path || '')
    } else {
      yield call(deleteLabel, action.payload.id)
    }

    yield put(updateEmailLabelSuccess())
    yield put(fetchEmailLabelsRequest())
  } catch (e: any) {
    console.log(e.response.data)
    yield put(
      updateEmailLabelError(
        e.response.data?.Message || 'Det skjedde en feil ved oppdatering'
      )
    )
  }
}

function* createLabel(
  action: PayloadAction<{ path: string; isEmail?: boolean }>
) {
  try {
    const { path, isEmail } = action.payload
    const client: IClient = yield select(getActiveClient)

    yield call(createLabelApi, client.id, path)

    yield put(createEmailLabelSuccess())
    yield put(fetchEmailLabelsRequest())

    const { type }: { type: string } = yield select(getModalState)

    if (type === NEW_LABEL_MODAL) {
      yield put(closeModal())

      const isEmailSet = isEmail || isEmail === undefined

      yield put(
        openModal({
          type: isEmailSet ? ADD_LABEL_TO_EMAIL_MODAL : ADD_LABEL_TO_SMS_MODAL,
        })
      )
    }
  } catch (e: any) {
    console.log(e.response.data)

    yield put(
      createEmailLabelError(
        e.response.data?.Message || 'Det skjedde en feil ved opprettelse'
      )
    )
  }
}

function* emailLabelsSaga() {
  yield takeEvery(fetchEmailLabelsRequest.type, fetchLabels)
  yield takeEvery(fetchEmailLabelDetailsRequest.type, fetchLabel)
  yield takeEvery(updateEmailLabelRequested.type, updateLabel)
  yield takeEvery(createEmailLabelRequested.type, createLabel)
}

export default emailLabelsSaga
